<template>
  <v-container>
      <v-layout row wrap>
        <v-flex xs12>
            <v-dialog
                v-model="dialogViewProduct"
                fullscreen
                pa-0
                >    
                   <v-card
                        v-if="currentProduct"
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="dialogViewProduct = false">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>View Product Details</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar> 

                        <v-card-title text-xs-center class="font-weight-bold primary--text">
                            {{currentProduct.title}}
                        </v-card-title>

                        <v-card-text>
                            <template  v-if="currentProduct.pics && currentProduct.pics.length>0">
                            <div>
                                
                                <gallery  v-if="currentProduct.pics && currentProduct.pics.length>0" :images="currentProduct.pics" :index="index" @close="index = null"></gallery>
                                <v-avatar
                                    v-if="currentProduct.pics && currentProduct.pics.length>0"
                                    :tile=true
                                    size="120"
                                    v-for="(image, imageIndex) in currentProduct.pics"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                >
                                    <img :src="image">
                                </v-avatar>
                        
                            </div>
                            </template>  
                            <v-divider></v-divider>
                            <v-layout row wrap>
                                <v-flex text-xs-center xs12 class="pt-2 pb-4">
                                    <v-btn raised dark :href="currentProduct.url" target="_blank">
                                        <v-icon color="white" class="pr-2">shopping_cart</v-icon>  Buy Now
                                    </v-btn>
                                </v-flex>
                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Price:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    ${{currentProduct.price}}
                                </v-flex>   

                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Shipping:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    <span v-if="currentProduct.shipping && currentProduct.shipping.cost===0"> Free Shipping</span><span v-else-if="currentProduct.shipping"> ${{currentProduct.shipping.cost}} est. shipping</span> <span v-else> Calc. Shipping</span>
                                </v-flex>  

                                <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                    Platform:
                                </v-flex>
                                <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                    {{currentProduct.platform}}
                                </v-flex> 
                                <template v-if="currentProduct.description">
                                    <v-flex text-xs-left xs4 class="pl-3 font-weight-bold pb-3">
                                        Description:
                                    </v-flex>
                                    <v-flex text-xs-left xs8 class="font-weight-bold pb-3">
                                        {{currentProduct.description}}
                                    </v-flex> 
                                </template>
                            </v-layout>
                        </v-card-text>

                   </v-card>
            </v-dialog>        
        </v-flex>
      </v-layout>
  <v-layout row wrap>
    <v-flex xs12>
          <v-tabs
      v-if="products"
      color="primary"
      dark
      slider-color="accent"
    >
      <v-tab
        v-for="(category,index) in Object.keys(products)"
        :key="'tab-' + index"
        ripple
      >
        {{ category }}

      </v-tab>
      <v-tab-item
        v-for="(c,i) in Object.keys(products)"
        :key="'tab-' + i"
      >
      <v-layout justify-space-between row wrap >
          <v-flex xs12 pb-4>
            
          </v-flex>
          <template v-for="(product,pindx) in products[c]">
            <v-flex xs6 pr-2 pl-2 pb-5 justify-center  :key="'vflex-' + pindx" v-if="product">
              <v-card>
                <v-img
                  @click="viewProduct(product)"
                  :src="product.featuredpic"
                  height="200px"
                >
                  <v-container
                    fill-height
                    fluid
                    pa-2
                  >
                    <v-layout fill-height>
                        <!--
                      <v-flex xs12 align-end flexbox>
                        <span class="caption font-weight-bold white--text shadow1" v-text="product.title"></span>
                      </v-flex>
                      -->
                    </v-layout>
                  </v-container>
                </v-img>
                <v-card-text class="pa-0">
                    <v-list two-line >
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end text-xs-left flexbox>
                                        <span class="caption" v-text="product.title"></span>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-layout row wrap>
                        <v-flex text-xs-left xs6>                            
                            <v-btn color="primary" small @click="viewProduct(product)">
                                View Item
                            
                            </v-btn>
                        </v-flex>
                        <v-flex xs6 text-xs-right>
                            <v-btn icon pl-4 :href="'sms:8033618821?body=Hey%20check%20this%20out%21%20https%3A%2F%2Fzzques.myquepsiphi.com%2Fsharedproduct.html%3Fp%3D' + product.platform.substring(0,2) + '%26itemid%3D' + product.itemid">
                                <v-icon>share</v-icon>
                            </v-btn>                               
                        </v-flex>
                         
                        
                        <v-flex xs12 pt-3 text-xs-right>
                            <span>${{product.price}}</span> + <span class="caption" v-if="product.shipping && product.shipping.cost===0"> Free Shipping</span><span class="caption" v-else-if="product.shipping"> ${{product.shipping.cost}} est. shipping</span><span class="caption" v-else>Calc. Shipping</span>

                        </v-flex>

                    </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </template>
        
      </v-layout>


      </v-tab-item>
    </v-tabs>  
    </v-flex>




  </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import VueGallery from 'vue-gallery'




  export default {
      data(){
          return{
               dialogViewProduct: false,
               currentProduct: null,
               index: null
          }

      },
    components: {
        'gallery': VueGallery
    },      
    created () {

       
   
    },      
    computed: {
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      products () {
          return this.$store.getters.products
      }
    },
    watch:{
          dialogViewProduct(value) {
            if(value===false){
                this.currentProduct = null                            
            }
        } 
    },
    methods:{   
      viewProduct: function (p) {
          this.currentProduct = p
          this.dialogViewProduct = true

      },                   
     
    }
  }
</script>

<style>
.flexlabel{
    font-weight: bold;

}
.shadow1{
    text-shadow: 1px 1px black;
}
</style>